import { render, staticRenderFns } from "./delete-product-modal.vue?vue&type=template&id=2beaa2d5&scoped=true&"
import script from "./delete-product-modal.vue?vue&type=script&lang=js&"
export * from "./delete-product-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beaa2d5",
  null
  
)

export default component.exports